import { Component, Input, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { User } from '../../models/user';
import { JWTService } from '../../services/jwt.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  role: string = '';
  @Input()
  currentUser: User | null = null;
  currentPage: string = '';
  activeItem: string = '';
  constructor(
    private router: Router,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private jwt: JWTService,
    private _location: Location
  ) {
    this.matIconRegistry.addSvgIcon(
      `tracking`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `/assets/images/tracker-white.svg`
      )
    );
    // this.matIconRegistry.addSvgIcon(
    //   `pricing`,
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(
    //     `/assets/images/price-range-white.svg`
    //   )
    // );
  }

  ngOnInit(): void {
    const UserDetails: any = this.jwt && this.jwt.getDecodedToken();
    this.currentUser = UserDetails;
    if (this.currentUser && this.currentUser.role) {
      this.role = this.currentUser.role;
    }
    this.currentPage = location.href;
  }

  backClicked() {
    this._location.back();
  }
  setActiveItem(page: string) {
    this.activeItem = page;
  }
}
